var _this = this;

import moment from 'moment';
import { random, range } from "lodash";

// utils
import { dateToTst, tstToMomentDate, dateToMomentDate, tstToDate, tstToMomentDayOfWeek, returnPromise } from '../../../utils/helpers';

// constants
import { TIME_DETAILS_FORMAT, DATEPICKER_FORMAT, DATE_DETAILS_FORMAT, COST_SHORT_DATE_FORMAT, COST_HOUR_FORMAT, COST_CHART_TYPE } from '../../../constants/data.constant';
import { COST_MODE } from './cost.constant';
import { GLOBAL_TYPES } from '../../../device/types/global.types';

export const calcDateByType = (date, type, direction = 1) => {
    switch (type) {
        case COST_CHART_TYPE.DAY:
            {
                date.setDate(date.getDate() + 1 * direction);
                break;
            }
        case COST_CHART_TYPE.WEEK:
            {
                date.setDate(date.getDate() + 7 * direction);
                break;
            }
        case COST_CHART_TYPE.MONTH:
            {
                date.setMonth(date.getMonth() + 1 * direction);
                break;
            }
    }

    return new Date(date);
};

export const convertDateToFromToByType = (currentDate, type) => {
    currentDate.setHours(0, 0, 0, 0);
    const currentTime = currentDate.getTime();
    let from, to, year, month;

    switch (type) {
        case COST_CHART_TYPE.DAY:
            {
                to = new Date(currentTime);
                from = new Date(currentTime);

                to.setHours(23, 59, 59, 0);
                // from.setHours(from.getHours() - 1);

                break;
            }
        case COST_CHART_TYPE.WEEK:
            {
                currentDate = moment(currentDate, DATEPICKER_FORMAT).startOf('isoweek').toDate();

                year = currentDate.getFullYear();
                month = currentDate.getMonth();
                from = new Date(year, month, currentDate.getDate());
                to = new Date(year, month, currentDate.getDate() + 6);

                to.setHours(23, 59, 59, 0);
                // from.setHours(from.getHours() - 7 * 1);

                break;
            }
        case COST_CHART_TYPE.MONTH:
            {
                year = currentDate.getFullYear();
                month = currentDate.getMonth();

                from = new Date(year, month, 1);
                to = new Date(year, month + 1, 0);

                to - from;
                to.setHours(23, 59, 59, 0);
                // from.setHours(from.getHours() -1);

                break;
            }
    }

    return {
        to,
        from
    };
};

export const xGetDateFormatted = (type, date, index) => {
    let tstDate = null;
    let xLabel = '';

    if (type === COST_CHART_TYPE.DAY) {
        tstDate = dateToTst(date);
        xLabel = tstToMomentDate(tstDate, COST_HOUR_FORMAT);
    }

    if (type === COST_CHART_TYPE.WEEK) {
        date.setHours(0, 0, 0, 0);
        tstDate = dateToTst(date);
        xLabel = tstToMomentDayOfWeek(tstDate);
    }

    if (type === COST_CHART_TYPE.MONTH) {
        date.setDate(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        tstDate = dateToTst(date);
        xLabel = tstToMomentDate(tstDate, COST_SHORT_DATE_FORMAT);
    }

    return tstDate;
};

let xLabels = [];

export const xGetLabel = (type, dates, date) => {
    // const index = dates.indexOf(date);
    const tstDate = date / 1000; //dateToTst(date);
    let label = '';

    if (type === COST_CHART_TYPE.DAY) label = tstToMomentDate(tstDate, COST_HOUR_FORMAT);
    if (type === COST_CHART_TYPE.WEEK) label = tstToMomentDayOfWeek(tstDate);
    if (type === COST_CHART_TYPE.MONTH) label = tstToMomentDate(tstDate, COST_SHORT_DATE_FORMAT);

    return label;

    // if (!!~xLabels.indexOf(xLabel)) {
    //     return '';
    // }

    // const indexDate = xLabels.findIndex(i=> i.dateRaw === tstDate);
    //
    // if (indexDate < 0) {
    //     const dateFormatted = xGetDateFormatted(type, date);
    //     const indexLabel = xLabels.findIndex(i=> i.label === label && i.dateFormatted === dateFormatted);
    //     xLabels.push({
    //         dateFormatted: dateFormatted,
    //         dateRaw: dateToTst(date),
    //         date: date,
    //         label: label,
    //         isFirstLabel: indexLabel < 0,
    //     });
    // }
    //
    // const a = xLabels.filter(i=> i.dateRaw=== tstDate);
    // if(a && a.length && a[0].isFirstLabel){
    //     return label;
    // }
    //
    // return ' ';
    //
    // const prevLabel = xLabels[index - 1] && xLabels[index - 1].label;
    // if (prevLabel === label /*&& indexLabel < 0*/) {
    //     return label + '_';
    // }
    //
    // return label;
};

export const compareCostItems = (a, b) => {
    if (+a.power > +b.power) return -1;
    if (+a.power < +b.power) return 1;

    return 0;
};

export const calcEnergyItems = (from, to, scale, costMode, serverResponse) => {
    const items = Object.keys(serverResponse).map((key, index) => {
        if (key !== 'sum') {
            const applianceItems = serverResponse[key];
            const deviceId = key.replace('/me/', '').replace('/app/E_total', '');
            // const applianceItems = serverResponse[`/me/${item.deviceId}/app/E_total`];

            return {
                deviceId,
                power: calcEnergySum(costMode, applianceItems)
            };
        }
    }).filter(i => !!i);

    return items;
};

export const getMaxDate = () => {
    const date = new Date();
    date.setHours(23, 59, 59, 0);

    return date;
};

const getDateDiff = (dateEarlier, dateLater, type) => {
    let day_period = 1000 * 60 * 60 * 24;

    if (type === COST_CHART_TYPE.DAY) {
        day_period = day_period * 1;
    }

    if (type === COST_CHART_TYPE.WEEK) {
        day_period = day_period * 7;
    }

    if (type === COST_CHART_TYPE.MONTH) {
        day_period = day_period * 30;
    }

    const result = (dateLater.getTime() - dateEarlier.getTime()) / day_period;
    return result;
};

export const isAllowNextPeriod = (currentDate, type) => {
    const dateDiff = getDateDiff(currentDate, getMaxDate(), type);
    return dateDiff > 1;
};

export const calcEnergySum = (costMode, items) => {
    const second = items[1];
    const first = items[0];

    if (!second.E_total || !first.E_total) {
        return -1;
    }

    if (costMode === COST_MODE.MONEY) {
        const result = -1;
        return parseFloat(result).toFixed(3);
    }

    const result = new Big(second.E_total.value).minus(first.E_total.value);
    return parseFloat(result).toFixed(3);
};

export const convertServerDataToModelData = (modelData, from, to, scale, type, data, N_sum = 1) => {
    const dt = parseFloat(new Big(to).minus(from).div(new Big(scale).minus(1).times(3600)));

    for (let i = 1; i < data.length; i++) {

        // Work-around for BE back returning sometimes lower values in a sequence        
        if (data[i].E_total.value < data[i - 1].E_total.value) {
            data[i].E_total.value = data[i - 1].E_total.value;
        }

        const sn = data[i];
        const sp = data[i - 1];
        let E = 0;
        let P = 0;

        E = sn.E_total.value - sp.E_total.value;
        P = parseFloat(new Big(1).div(dt).times(E));

        modelData.chart.items.push({
            x: tstToDate(sn.time, DATE_DETAILS_FORMAT),
            y: +P.toFixed(3)
        });
    }

    // min max
    modelData.chart.min = {
        x: modelData.chart.items.length ? modelData.chart.items[0].x : tstToDate(from, DATE_DETAILS_FORMAT),
        y: modelData.chart.items.length ? +Math.min(...modelData.chart.items.map(i => i.y)).toFixed(3) : 0
    };
    modelData.chart.max = {
        x: modelData.chart.items.length ? modelData.chart.items[modelData.chart.items.length - 1].x : tstToDate(to, DATE_DETAILS_FORMAT),
        y: modelData.chart.items.length ? +Math.max(...modelData.chart.items.map(i => i.y)).toFixed(3) : 1
    };

    // labels
    xLabels = [];
    modelData.chart.xLabels = modelData.chart.items.length ? modelData.chart.items.map(i => i.x) : [tstToDate(from, DATE_DETAILS_FORMAT), tstToDate(to, DATE_DETAILS_FORMAT)];
    modelData.chart.xGetLabel = xGetLabel.bind(_this, type, modelData.chart.xLabels);
    modelData.chart.xTickValues = modelData.chart.xLabels.map(x => xGetLabel(type, modelData.chart.xLabels, x));

    // modelData.chart.xLabels = [...new Set(modelData.chart.xLabels.map(item => item))];

    const delta = parseFloat(new Big(modelData.chart.max.y).minus(modelData.chart.min.y).div(scale));

    modelData.chart.yTickValues = [];
    if (delta > 0) {
        for (let i = +modelData.chart.min.y; i <= +modelData.chart.max.y; i += delta) {
            modelData.chart.yTickValues.push(+i.toFixed(2));
        }
    } else {
        modelData.chart.yTickValues.push(modelData.chart.min.y);
    }

    if (modelData.chart.min.x > modelData.chart.max.x) {
        throw 'Dates did not sort in cost chart data';
    }

    return modelData;
};

export const getCostModeLabel = settingsState => {
    const labelCostMode = settingsState.settings[GLOBAL_TYPES.COST_MODE] === COST_MODE.WATT ? 'kWh' : '$';

    return labelCostMode;
};

export const getMockData = params => {
    let delta = 60 * 5;
    const normalData = range(1, 30).map(i => ({
        time: Date.now() + delta * i,
        E_total: {
            value: random(1, 100)
        },
        M: random(1, 10) / 1234
    }));

    const data = {
        sum: normalData
    };

    return returnPromise(data);

    /*
     modelData.chart.items = [
     // 1
     {
     x: 1,
     xLabel: 1,
     y: 5,
     yLabel: 5,
     },
     // 2
     {
     x: 2,
     xLabel: 2,
     y: 5,
     yLabel: 5,
     },
     // 3
     {
     x: 3,
     xLabel: 3,
     y: 5,
     yLabel: 5,
     },
     // 4
     {
     x: 4,
     xLabel: 4,
     y: 15,
     yLabel: 15,
     },
     // 5
     {
     x: 5,
     xLabel: 5,
     y: 5,
     yLabel: 5,
     },
     // 6
     {
     x: 7,
     xLabel: 7,
     y: 5,
     yLabel: 5,
     },
     // 7
     {
     x: 8,
     xLabel: 8,
     y: 2,
     yLabel: 2,
     },
     // 8
     {
     x: 9,
     xLabel: 9,
     y: 0,
     yLabel: 0,
     },
     // 9
     {
     x: 12,
     xLabel: 12,
     y: 5,
     yLabel: 5,
     },
     // 10
     {
     x: 13,
     xLabel: 13,
     y: 15,
     yLabel: 15,
     },
     // 11
     {
     x: 14,
     xLabel: 14,
     y: 22,
     yLabel: 22,
     },
     // 12
     {
     x: 15,
     xLabel: 15,
     y: 25,
     yLabel: 25,
     },
     // 13
     {
     x: 16,
     xLabel: 16,
     y: 25,
     yLabel: 25,
     },
     // 14
     {
     x: 17,
     xLabel: 17,
     y: 5,
     yLabel: 5,
     },
     // 15
     {
     x: 18,
     xLabel: 18,
     y: 5,
     yLabel: 5,
     },
     // 16
     {
     x: 19,
     xLabel: 19,
     y: 5,
     yLabel: 5,
     },
     // 17
     {
     x: 20,
     xLabel: 20,
     y: 5,
     yLabel: 5,
     },
     // 18
     {
     x: 23,
     xLabel: 23,
     y: 5,
     yLabel: 5,
     },
     // 19
     {
     x: 24,
     xLabel: 24,
     y: 1,
     yLabel: 1,
     },
     // 20
     {
     x: 25,
     xLabel: 25,
     y: 5,
     yLabel: 5,
     },
     // 21
     {
     x: 26,
     xLabel: 26,
     y: 7,
     yLabel: 7,
     },
     // 22
     {
     x: 27,
     xLabel: 27,
     y: 10,
     yLabel: 10,
     },
     // 23
     {
     x: 28,
     xLabel: 28,
     y: 12,
     yLabel: 12,
     },
     // 24
     {
     x: 30,
     xLabel: 30,
     y: 35,
     yLabel: 35,
     },
     ];
     */
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/cost/cost.helper.js